import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

export const ComparePackageTrayStyles = () => ({
  container: {
    margin: '0 auto',
    position: 'fixed',
    bottom: 0,
    left: '7%',
    width: '85%',
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      width: '100%',
      left: '0%'
    },
    zIndex: 1302,
    display: 'flex',
    flexDirection: 'column',
    padding: '14px 22px 14px 21px',
    backgroundColor: colorPalette?.neutral_white?.main,
    borderRadius: '8px 8px 0 0',
    boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.25)'
  },
  titleContainer: {
    display: 'flex',
    width: '100%'
  },
  titleText: {
    fontWeight: 500,
    fontSize: '16px !important',
    fontFamily: 'roboto-medium',
    lineHeight: '26px'
  },
  titleBox: {
    display: 'flex',
    width: '70%',
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      width: '90%',
      justifyContent: 'space-between'
    }
  },
  arrowContainer: {
    display: 'flex',
    justifyContent: 'end',
    width: '30%',
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      width: '10%'
    }
  },
  arrowStyles: {
    width: "20px",
    height: "20px",
    cursor: "pointer"
  },
  comparePackagesChipsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    "& .MuiPaper-root": {
      margin: "0px !important"
    }
  },
  genrePacksChipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '10px',
    [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.sm)]: {
      gap: '7px 16px'
    },
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      gap: '7px 8px'
    }
  },
  genreChip: {
    border: `1px solid ${colorPalette?.gray?.[500]}`,
    borderRadius: '8px',
    padding: '0px 8px !important',
    margin: '0px !important',
    '& span': {
      padding: '0px !important'
    },
    [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.md)]: {
      width: '190px',
      height: '40px',
      fontSize: '16px !important'
    },
    [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
      width: '175px',
      height: '36px',
      fontSize: '16px !important'
    },
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      width: '155px',
      height: '36px',
      fontSize: '14px !important'
    },
    "&.active-chip": {
      backgroundColor: colorPalette?.jet?.main,
      color: `${colorPalette?.neutral_white?.main} !important`
    },
    "&:focus-visible": {
      outline: `4px solid transparent !important`,
      outlineColor: '#3885e1 !important',
      outlineOffset: '0px',
      backgroundColor: colorPalette?.neutral_white?.main
    },
    "& svg": {
      width: '28px !important',
      height: '28px !important',
      [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
        width: '24px !important',
        height: '24px !important'
      },
      [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
        width: '20px !important',
        height: '20px !important'
      }
    }
  },
  signatureTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '10px',
    borderBottom: `1px solid ${colorPalette?.gray?.[500]}`,
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      justifyContent: 'space-between'
    }
  },
  subHeading1TitleText: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '26px',
    fontFamily: 'roboto-medium',
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.md)]: {
      fontSize: '16px',
      lineHeight: '20.8px'
    }
  },
  subHeading2TitleText: {
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'roboto-medium',
    lineHeight: '20.8px',
    color: "#000000",
    [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.md)]: {
      fontSize: '20px',
      lineHeight: '26px'
    }
  },
  ctaContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      justifyContent: 'space-between'
    }
  },
  cta1Button: {
    width: '195px',
    height: '48px',
    margin: '0px !important',
    [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
      width: '142px',
      height: '36px'
    },
    [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.sm)]: {
      width: '155px',
      height: '36px'
    }
  },
  cta2Button: {
    height: '56px',
    margin: '0px !important',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '5px',
      '& svg': {
        width: '24px',
        height: '24px'
      }
    }
  }
})
